"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const React = __importStar(require("react"));
const react_select_1 = __importStar(require("react-select"));
const creatable_1 = __importDefault(require("react-select/creatable"));
const async_1 = __importDefault(require("react-select/async"));
const async_creatable_1 = __importDefault(require("react-select/async-creatable"));
const CustomRender_1 = require("./CustomRender");
const LabelTooltipDecorator_1 = __importDefault(require("../label-tooltip-decorator/LabelTooltipDecorator"));
const clsx_1 = require("clsx");
const eventUtils_1 = require("../common/eventUtils");
// css baseclass prefix
const prefix = 'tk-select';
class Dropdown extends React.Component {
    constructor(props) {
        super(props);
        this.getDropdownTag = (asyncOptions, addNewOptions) => {
            let DropdownTag = react_select_1.default;
            if (asyncOptions && !addNewOptions) {
                DropdownTag = async_1.default;
            }
            else if (asyncOptions && addNewOptions) {
                DropdownTag = async_creatable_1.default;
            }
            else if (!asyncOptions && addNewOptions) {
                DropdownTag = creatable_1.default;
            }
            return DropdownTag;
        };
        this.handleChange = (selectedOption, meta) => {
            const isClearingTermSearch = this.lastSelectedOption === this.searchHeaderOption && !selectedOption;
            this.lastSelectedOption = selectedOption;
            if (this.props.onChange &&
                !(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.searchHeader) &&
                !isClearingTermSearch) {
                this.props.onChange({ target: { value: selectedOption } });
            }
            if (this.props.onTermSearch && (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.searchHeader)) {
                this.props.onTermSearch(selectedOption);
            }
            if (meta.action === 'clear' && this.props.onClear) {
                this.props.onClear();
            }
        };
        this.handleBlur = () => {
            const { value } = this.props;
            if (this.props.onBlur) {
                this.props.onBlur({ target: { value: value } });
            }
        };
        this.handleKeyDown = (e) => {
            var _a, _b;
            // also open menu with 'enter' key (not supported in the default react-select behavior)
            if (e.target.nodeName === 'INPUT' &&
                e.key === eventUtils_1.Keys.ENTER) {
                this.myRef.current.setState({ menuIsOpen: true });
            }
            else if (e.target.nodeName === 'INPUT' &&
                e.key === eventUtils_1.Keys.ESC) {
                // Avoid closing modal containing the dropdown when closing the dropdown via ESC
                if (this.myRef.current.state.menuIsOpen) {
                    e.stopPropagation();
                }
            }
            (_b = (_a = this.props).onKeyDown) === null || _b === void 0 ? void 0 : _b.call(_a, e);
        };
        this.internalFiltering = this.props.filterFunction
            ? (o, input) => this.props.filterFunction(o.data, input)
            : (0, react_select_1.createFilter)(null);
        this.filter = (o, input) => {
            return o.data.searchHeader || this.internalFiltering(o, input);
        };
        this.handleIsOptionDisabled = this.props.isOptionDisabled
            ? (option) => this.props.isOptionDisabled(option)
            : undefined;
        this.handleIsOptionSelected = this.props.isOptionSelected
            ? (option) => this.props.isOptionSelected(option)
            : (option, selectValue) => selectValue === null || selectValue === void 0 ? void 0 : selectValue.some((i) => i === option);
        this.internalAsyncOptions = async (inputValue) => {
            var _a;
            return (_a = this.props) === null || _a === void 0 ? void 0 : _a.asyncOptions(inputValue).then((options) => new Promise((resolve) => resolve(this.props.enableTermSearch
                ? [this.searchHeaderOption, ...options]
                : options)));
        };
        this.bindValue = this.props.bindValue
            ? (option) => option[this.props.bindValue]
            : undefined;
        this.myRef = React.createRef();
        this.searchHeaderOption = Object.assign({}, CustomRender_1.firstOption);
        const { asyncOptions, addNewOptions, isMultiSelect, hideSelectedOptions, closeMenuOnSelect, displayArrowIndicator, } = this.props;
        this.state = {
            DropdownTag: this.getDropdownTag(asyncOptions, addNewOptions),
            selectedOption: null,
            hideSelectedOptions: hideSelectedOptions || isMultiSelect,
            closeMenuOnSelect: closeMenuOnSelect || !isMultiSelect,
            displayArrowIndicator: displayArrowIndicator || !isMultiSelect,
        };
    }
    componentDidMount() {
        const { onInit, value } = this.props;
        if (onInit && value) {
            onInit(value);
        }
    }
    get internalOptions() {
        var _a;
        if ((_a = this.props) === null || _a === void 0 ? void 0 : _a.options) {
            return this.props.enableTermSearch
                ? [this.searchHeaderOption, ...this.props.options]
                : this.props.options;
        }
    }
    render() {
        const { hideSelectedOptions, closeMenuOnSelect, displayArrowIndicator, DropdownTag, } = this.state;
        const _a = this.props, { 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        addNewOptions, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        asyncOptions, autoScrollToCurrent, bindLabel, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        bindValue, blurInputOnSelect, className, defaultOptions, defaultValue, enableTermSearch, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        filterFunction, iconName, id, inputAlwaysDisplayed, inputValue, isDisabled, isInputClearable, isMultiSelect, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        isOptionDisabled, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        isOptionSelected, isTypeAheadEnabled, label, maxHeight, maxMenuHeight, menuIsOpen, menuPlacement, menuPortalStyles, menuPortalTarget, menuShouldBlockScroll, menuShouldScrollIntoView, mode, name, noOptionMessage, placeHolder, helperText, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onBlur, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onChange, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onClear, onCopy, onCut, onDrag, onFocus, onInputChange, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onKeyDown, onKeyUp, onMenuOpen, onMenuClose, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onTermSearch, optionRenderer, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        options, showRequired, size, tabSelectsValue, tagRenderer, termSearchMessage, tooltip, tooltipCloseLabel, value, variant } = _a, otherProps = __rest(_a, ["addNewOptions", "asyncOptions", "autoScrollToCurrent", "bindLabel", "bindValue", "blurInputOnSelect", "className", "defaultOptions", "defaultValue", "enableTermSearch", "filterFunction", "iconName", "id", "inputAlwaysDisplayed", "inputValue", "isDisabled", "isInputClearable", "isMultiSelect", "isOptionDisabled", "isOptionSelected", "isTypeAheadEnabled", "label", "maxHeight", "maxMenuHeight", "menuIsOpen", "menuPlacement", "menuPortalStyles", "menuPortalTarget", "menuShouldBlockScroll", "menuShouldScrollIntoView", "mode", "name", "noOptionMessage", "placeHolder", "helperText", "onBlur", "onChange", "onClear", "onCopy", "onCut", "onDrag", "onFocus", "onInputChange", "onKeyDown", "onKeyUp", "onMenuOpen", "onMenuClose", "onTermSearch", "optionRenderer", "options", "showRequired", "size", "tabSelectsValue", "tagRenderer", "termSearchMessage", "tooltip", "tooltipCloseLabel", "value", "variant"]);
        return ((0, jsx_runtime_1.jsxs)("div", { className: (0, clsx_1.clsx)(className, 'tk-input-group', `tk-input-group--${size}`, {
                'tk-input-group--disabled': isDisabled,
            }), children: [(0, jsx_runtime_1.jsx)(DropdownTag, Object.assign({ styles: {
                        menuPortal: (base) => (Object.assign(Object.assign({}, base), menuPortalStyles)),
                        valueContainer: (base) => (Object.assign(Object.assign({}, base), { maxHeight: `${maxHeight}px` })),
                        input: (base) => (Object.assign(Object.assign({}, base), { margin: size === 'small' ? '0 2px' : undefined, color: 'inherit' })),
                        multiValue: (base) => (Object.assign(Object.assign({}, base), { margin: '0' })),
                    }, parentInstance: this, ref: this.myRef, selectRef: this.myRef, displayArrowIndicator: displayArrowIndicator, optionRenderer: optionRenderer, tagRenderer: tagRenderer, isClearable: isInputClearable, components: {
                        DropdownIndicator: CustomRender_1.DropdownIndicator,
                        Control: CustomRender_1.Control,
                        SingleValue: CustomRender_1.SingleValue,
                        Input: CustomRender_1.Input,
                        Option: CustomRender_1.DefaultOptionRenderer,
                        MultiValueContainer: CustomRender_1.MultiValueContainerOverride,
                        MultiValue: CustomRender_1.DefaultTagRenderer,
                        ClearIndicator: CustomRender_1.ClearIndicator,
                        MultiValueRemove: () => null,
                        NoOptionsMessage: CustomRender_1.NoOptionsMessage,
                        MenuList: CustomRender_1.DropdownList,
                        LoadingIndicator: () => null,
                        LoadingMessage: CustomRender_1.LoadingMessage,
                    }, defaultValue: defaultValue, id: id, label: label, name: name, className: (0, clsx_1.clsx)(prefix, { [`${prefix}--${variant}`]: variant }, { [`${prefix}--${size}`]: size }), closeMenuOnSelect: closeMenuOnSelect, classNamePrefix: prefix, value: value, inputValue: inputValue, inputAlwaysDisplayed: inputAlwaysDisplayed, onChange: this.handleChange, onBlur: this.handleBlur, onCopy: onCopy, onCut: onCut, onDrag: onDrag, onFocus: onFocus, onInputChange: onInputChange, onKeyDown: this.handleKeyDown, onKeyUp: onKeyUp, options: this.internalOptions, loadOptions: this.internalAsyncOptions, defaultOptions: defaultOptions !== undefined ? defaultOptions : true, hideSelectedOptions: hideSelectedOptions, placeholder: placeHolder, isMulti: isMultiSelect, isDisabled: isDisabled, iconName: iconName, noOptionMessage: noOptionMessage, filterOption: this.filter, isSearchable: isTypeAheadEnabled, isOptionDisabled: this.handleIsOptionDisabled, isOptionSelected: this.handleIsOptionSelected, menuPlacement: menuPlacement, maxMenuHeight: maxMenuHeight, mode: mode ? mode : 'aligned', autoScrollToCurrent: autoScrollToCurrent, menuIsOpen: menuIsOpen, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, tabSelectsValue: tabSelectsValue, enableTermSearch: enableTermSearch, termSearchMessage: termSearchMessage, getOptionValue: this.bindValue, getOptionLabel: bindLabel, blurInputOnSelect: blurInputOnSelect, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView }, otherProps)), (0, jsx_runtime_1.jsx)(LabelTooltipDecorator_1.default, { htmlFor: id, label: label, placement: 'top', tooltip: tooltip, tooltipCloseLabel: tooltipCloseLabel, showRequired: showRequired }), helperText && (0, jsx_runtime_1.jsx)("div", { id: `${id}-input__helper`, className: "tk-input__helper", children: helperText })] }));
    }
}
exports.Dropdown = Dropdown;
Dropdown.defaultProps = {
    isDisabled: false,
    isMultiSelect: false,
    addNewOptions: false,
    isInputClearable: false,
    isTypeAheadEnabled: true,
    autoScrollToCurrent: false,
    enableTermSearch: false,
    menuPlacement: 'auto',
    menuPortalStyles: {},
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: true,
    size: 'medium',
    bindLabel: (option) => option === null || option === void 0 ? void 0 : option.label,
};
exports.default = Dropdown;
